
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
//import reportWebVitals from './reportWebVitals';
import { AuthProivider, AuthContext } from "./Contexts/AuthContext";
import { BrowserRouter as Router } from 'react-router-dom';
import { ProductProvider, ProductContext } from './Contexts/ProductContext';


export { AuthContext, ProductContext };


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <AuthProivider>
      <ProductProvider>
        <App />
      </ProductProvider>
    </AuthProivider>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
